import { type ParsedAsset } from '@aikoa/common'
import { useTranslations } from '@aikoa/i18n/react'
import { useMemo } from 'react'
import { AddPriceInline } from '~/components/assets/AddPriceInline'
import { collectAssetDetails } from '~/components/assets/propertyUtils'
import { type ButtonSize, type ButtonVariant } from '~/components/ui/button'

type PropertyPriceActionProps = {
  asset: ParsedAsset
  onSuccess?: () => void
  triggerClassName?: string
  triggerVariant?: ButtonVariant
  triggerSize?: ButtonSize
  triggerLabel?: string
}

export function PropertyPriceAction({
  asset,
  onSuccess,
  triggerClassName,
  triggerVariant,
  triggerSize,
  triggerLabel,
}: PropertyPriceActionProps) {
  const { t } = useTranslations('property')
  const { askingPrice } = useMemo(() => collectAssetDetails(asset), [asset])
  const relationType = asset.relations[0]?.relation_type

  return (
    <AddPriceInline
      key={`add-price-${askingPrice?.id ?? asset.id}`}
      currentPrice={askingPrice?.price}
      assetId={asset.id}
      isProspect={relationType === 'prospect'}
      onSuccess={onSuccess}
      triggerClassName={triggerClassName}
      triggerVariant={triggerVariant ?? (askingPrice ? 'outline' : 'primary')}
      triggerSize={triggerSize ?? (askingPrice ? 'xs' : 'lg')}
      triggerLabel={
        triggerLabel ?? (askingPrice ? t(($) => $.actions.changePrice) : t(($) => $.actions.addPrice))
      }
    />
  )
}
